module.exports = __webpack_public_path__ + "img/landing37.128d4717.jpg";